import { useDisclosure } from "@chakra-ui/react";
import { useState } from "react";
import { BiPlus } from "react-icons/bi";
import { Button } from "../../../components/ui/button";
import Workspace from "../../../components/workspace";
import GroupTypeListContainer from "./group-list-container";
import { GroupTypeForm } from "./group-type-form";

const GroupTypeManagement = () => {
   const [searchQuery, setSearchQuery] = useState("");
   const formModal = useDisclosure();

   return (
      <>
         <GroupTypeForm modal={formModal} />
         <Workspace.TopBar heading="Group Type Management" />
         <Workspace.WorkspaceActions>
            <Button variant="primary" onClick={formModal.onOpen}>
               <span className="inline-flex items-center gap-2">
                  <BiPlus />
                  Create new group type
               </span>
            </Button>
         </Workspace.WorkspaceActions>
         <Workspace.ComponentWrapper>
            <Workspace.ListContainerHeader>
               <Workspace.HeaderPadding>
                  <Workspace.ListTitleWrapper>
                     <Workspace.ListTitle>Group Types</Workspace.ListTitle>
                     <Workspace.HeaderSearchWrapper>
                        <Workspace.HeaderSearchForm onSubmit={setSearchQuery} />
                     </Workspace.HeaderSearchWrapper>
                  </Workspace.ListTitleWrapper>
               </Workspace.HeaderPadding>
            </Workspace.ListContainerHeader>
            <GroupTypeListContainer searchQuery={searchQuery} />
         </Workspace.ComponentWrapper>
      </>
   );
};

export default GroupTypeManagement;
